import React from 'react';

import { useSelector } from 'react-redux';
import ModalPopup from '../sub-components/ModalPopup';
import { OwnWebSocket } from '../OwnWebsocket';
import Notification from './Notification';
import AskQuestion from './AskQuestion';
import CertificateDownload from './CertificateDownload';
import LoadData from './LoadData';
import AskAQuery from './AskAQuery';

const OtherItems = () => {
   
  const LoginLogout = useSelector(state => state.LoginLogout);

    const OtherItemsInner = () => {

        /******check user is loggedin ******/
        if(Object.keys(LoginLogout.user).length != 0 ){

            return <> 
                            <LoadData/>

                            <OwnWebSocket />
                            
                            <ModalPopup />

                            <Notification />

                            <AskAQuery/>

                            <AskQuestion />

                            {/* <CertificateDownload /> */}
                    </>
        }
    }

    return (
        <>
            <OtherItemsInner />
        </>
    )
}


export default OtherItems